import React from 'react';
import { AlertTriangle, Shield, X } from 'lucide-react';
import { useSecurityContext } from '../hooks/useSecurityContext';

interface SecurityWarningsProps {
  onDismiss?: () => void;
}

const SecurityWarnings: React.FC<SecurityWarningsProps> = ({ onDismiss }) => {
  const { securityWarnings, isSecureConnection } = useSecurityContext();
  const [dismissed, setDismissed] = React.useState(false);

  if (dismissed || securityWarnings.length === 0) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    onDismiss?.();
  };

  const getSeverityColor = (warning: string) => {
    if (warning.includes('Unsichere Verbindung')) {
      return 'bg-red-50 border-red-200 text-red-800';
    }
    if (warning.includes('Browser')) {
      return 'bg-orange-50 border-orange-200 text-orange-800';
    }
    return 'bg-yellow-50 border-yellow-200 text-yellow-800';
  };

  return (
    <div className="fixed top-4 right-4 max-w-md z-50">
      <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center">
            <Shield className="h-5 w-5 text-red-600 mr-2" />
            <h3 className="font-semibold text-gray-900">Sicherheitshinweise</h3>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
        
        <div className="space-y-2">
          {securityWarnings.map((warning, index) => (
            <div
              key={index}
              className={`p-3 rounded-lg border flex items-start ${getSeverityColor(warning)}`}
            >
              <AlertTriangle className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
              <span className="text-sm">{warning}</span>
            </div>
          ))}
        </div>

        {!isSecureConnection && (
          <div className="mt-3 p-3 bg-red-100 rounded-lg">
            <p className="text-sm text-red-800 font-medium">
              Empfehlung: Verwenden Sie HTTPS für maximale Sicherheit.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecurityWarnings;